<template>
  <div class="page-container">
    <slot/>
  </div>
</template>
<script>
export default {
  props: {},
};
</script>
<style lang="stylus" scoped>
@import '../../assets/css/main.styl';

.page-container {
  max-width: 100%;
  padding: 20px;
  margin: 0 auto;
}
</style>
